export default {
  divider: {
    padding: '10px 0'
  },
  divider_border: {
    height: '0',
    margin: '0',
    padding: '0',
    lineHeight: '0'
  }
};
